import classes from './DownloadDocumentLink.module.css'
import { getDownloadPDFWithUrl } from '../../lib/fetchApi'
import { useSelector } from 'react-redux'
import { useState } from 'react'

const DownloadDocumentLink = ({children, url}) => {
    const [loading, setLoading] = useState(false)
    const userToken = useSelector(state => state.user.token)

    const getDocument = async () => {
        setLoading(true)

        let doc = await getDownloadPDFWithUrl(userToken, url)

        
        if (doc) {
            let file = window.URL.createObjectURL(doc);
            window.open(file, '_blank');
        }

        setLoading(false)
    }

    return <>
        <button onClick={getDocument} className={classes.link} disabled={loading}>
            {!loading && <i className="ti ti-printer"></i>}
            {loading && <span className='loader dark'></span>}
            {children}
        </button>
    </>
}

export default DownloadDocumentLink